import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import './index.scss';

const BankAccountDisclaimerModal = ({ isModalOpen, title, content, handleClose, confirmText = 'Close' }) => {
    const { t } = useTranslation();
    return (
        <>
            <Modal
                open={isModalOpen}
                onOk={handleClose}
                onCancel={handleClose}
                footer=""
                centered
                width={1500}
                classNames={{ body: 'custom-modal-body' }}
                top={20}
            >
                <div className="disclaimer-modal">
                    <p className="text-center disclaimer-modal-content" dangerouslySetInnerHTML={{ __html: content }}></p>
                    <div className="custom-modal-body disclaimer-modal-button">
                        <button
                            type="button"
                            onClick={handleClose}
                        >
                            {t(confirmText)}
                        </button>
                    </div>
                </div>

            </Modal>
        </>
    )
}
export default BankAccountDisclaimerModal;